<template>
  <div :class="['contact-preferences', { 'with-error': contactPreferencesError }]">
    <h2 class="title">Kontaktpräferenz</h2>
    <p class="contact-preferences__sub-title">Welche Kontaktwege bevorzugen Sie? Sie entscheiden!</p>
    <form>
      <div
        :class="['radio-form-item recommendation', { active: contactPreferences === false }]"
        @click="() => handleCheckboxChange(false)"
      >
        <input :checked="contactPreferences === false" type="radio" />
        <div>
          <div class="radio-form-item__top-content">
            <div>
              <h4>Telefonisch</h4>
            </div>
            <p>
              Ich willige in die telefonische Kontaktaufnahme ein. Sollte PKW.de für die weitere Abwicklung nähere Informationen benötigen, darf PKW.de mich hierzu anrufen. Falls meinerseits Fragen aufkommen, kann ich jederzeit unter +49 211 946 255 0 anrufen.
            </p>
            <p class="contact-preferences__bell">
              <i class="fas fa-bell" />
              <b>Unser Tipp</b> für eine noch schnellere Abwicklung
            </p>
          </div>
        </div>
      </div>
      <div :class="['radio-form-item', { active: contactPreferences === true }]" @click="() => handleCheckboxChange(true)">
        <input :checked="contactPreferences === true" type="radio" />
        <div>
          <div class="radio-form-item__top-content">
            <div>
              <h4>Nur online</h4>
            </div>
            <p>
              Ich wünsche keinen telefonischen Kontakt und möchte die gesamte Kommunikation inkl. Vertragsabschluss online durchführen. Falls meinerseits Fragen aufkommen, kann ich jederzeit unter +49 211 946 255 0 anrufen.
            </p>
          </div>
        </div>
      </div>
      <p v-if="contactPreferencesError" class="error">Bitte Option wählen.</p>
      <div class="btns">
        <button class="btn" @click="updateOrderData">{{ editMode ? 'Änderungen übernehmen' : 'Nächster Schritt'}}</button>
      </div>
    </form>
  </div>
</template>

<script>
export default {
  props: ['order', 'editMode'],
  data() {
    return {
      contactPreferences:
        this.order.only_available_online !== undefined ? this.order.only_available_online : '',
      contactPreferencesError: false,
      showModal: false,
    };
  },
  watch: {
    contactPreferences(val) {
      if (val && this.contactPreferencesError) {
        this.contactPreferencesError = false;
      }
    },
  },
  methods: {
    updateOrderData(e) {
      e.preventDefault();
      const isValid = this.validateForm();
      if (isValid) {
        this.sending = true;
        const params = {
          only_available_online: this.contactPreferences,
        };
        this.$emit('updateOrderStep', this.order.token, params);
      }
    },
    validateForm() {
      let noError = true;
      if (this.contactPreferences === '') {
        this.contactPreferencesError = true;
        noError = false;
      } else {
        this.contactPreferencesError = false;
      }
      if (noError) {
        this.contactPreferencesError = false;
      }
      return noError;
    },
    handleCheckboxChange(value) {
      this.contactPreferences = value;
    },
    openModal() {
      this.showModal = true;
    },
    closeModal() {
      this.showModal = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.contact-preferences {
  padding: 30px 0.625rem;

  &__bell {
    font-size: 14px;
    color: $blue;
    i {
      margin-right: 10px;
    }
  }

  @include breakpoint(desktop) {
    padding: 30px 0;
    &__bell {
      margin-right: 0;
      text-align: right;
    }
  }

  &__sub-title {
    font-size: 18px;
    margin-bottom: 30px;
  }

  .radio-form-item {
    margin-bottom: 10px;
  }
  .check-list {
    margin-top: 20px;
  }
  .btn {
    margin-top: 10px;
  }
  &.with-error {
    .radio-form-item {
      border-color: $red;
    }
    .title {
      color: $red;
    }
    .error {
      font-size: 12px;
      line-height: 24px;
      color: $red;
    }
  }
  .btns {
    display: flex;
    justify-content: flex-end;
  }
}
</style>
